import React, { useState, useEffect } from "react";
import LZString from "lz-string";

const OrderTable = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [showDiscountOrders, setShowDiscountOrders] = useState(false);
    const [dbCollections, setDbCollections] = useState({}); // Store API response

    useEffect(() => {
        // Fetch the collections data from the API
        const fetchCollections = async () => {
            try {
                const response = await fetch(
                    "https://bymolive-backend-995926394015.us-central1.run.app/api/all-collections"
                );
                if (!response.ok) throw new Error("Failed to fetch collections.");
                const data = await response.json();
                setDbCollections(data);
            } catch (err) {
                console.error("Error fetching collections:", err.message);
            }
        };

        fetchCollections();

        // Load and decompress orders from session storage
        const compressedData = sessionStorage.getItem("rawOrdersData");
        if (compressedData) {
            const decompressedData = JSON.parse(LZString.decompress(compressedData));
            const sortedOrders = decompressedData.sort(
                (a, b) => new Date(b.created_at) - new Date(a.created_at)
            ); // Sort orders by creation date descending
            setOrders(sortedOrders);
            setFilteredOrders(sortedOrders);
        } else {
            console.warn("No orders found in session storage.");
        }
    }, []);


    // Search and filter logic
    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();

        let filtered = orders;
        if (showDiscountOrders) {
            filtered = filtered.filter((order) => order.discount_codes?.length > 0);
        }

        const searchFiltered = filtered.filter((order) => {
            const { order_number, discount_codes, email } = order;
            const discountCode = discount_codes?.[0]?.code?.toLowerCase() || "";

            return (
                order_number.toString().includes(query) ||
                discountCode.includes(query) ||
                email.toLowerCase().includes(query)
            );
        });

        setFilteredOrders(query === "" ? filtered : searchFiltered);
    };

    const handleShowDiscountOrders = () => {
        const filtered = showDiscountOrders
            ? orders
            : orders.filter((order) => order.discount_codes?.length > 0);

        setShowDiscountOrders(!showDiscountOrders);
        setFilteredOrders(filtered);
    };

    // Calculate days difference between today and the given date
    const calculateDaysDifference = (date) => {
        const currentDate = new Date();
        const givenDate = new Date(date);
        const timeDifference = currentDate - givenDate;
        return Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days
    };



    const [showPendingOrders, setShowPendingOrders] = useState(false); // State to toggle "in asteptare" orders

    const handleShowPendingOrders = () => {
        const filtered = showPendingOrders
            ? orders
            : orders.filter((order) => {
                const orderNumberWithB = `B${order.order_number}`;
                const dbMatch = Object.values(dbCollections).flat().find(
                    (entry) => entry.id === orderNumberWithB
                );
                return dbMatch?.status === "in asteptare";
            });

        setShowPendingOrders(!showPendingOrders);
        setFilteredOrders(filtered);
    };



    return (
        <div style={{ padding: "20px" }}>
            <h1>Shopify Orders</h1>

            {/* Search Bar */}
            <input
                type="text"
                placeholder="Search by order number, email, or discount code..."
                onChange={handleSearch}
                style={{
                    width: "100%",
                    padding: "10px",
                    marginBottom: "20px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                }}
            />

            {/* Discount Orders Button */}
            <div>
                <button
                    onClick={handleShowDiscountOrders}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: showDiscountOrders ? "#ff5722" : "#4caf50",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        marginRight: "10px",
                    }}
                >
                    {showDiscountOrders ? "Show All Orders" : "Show Orders with Discount"}
                </button>

                <button
                    onClick={handleShowPendingOrders}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: showPendingOrders ? "#ff5722" : "#4caf50",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    {showPendingOrders ? "Show All Orders" : "Show Pending Orders"}
                </button>
            </div>





            {/* Orders Table */}
            {filteredOrders.length > 0 ? (
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "20px",
                    }}
                >
                    <thead>
                    <tr>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>Date</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>Order Number</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>Email</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>Discount Code</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>Total Amount</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>DB Check</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>Statuses</th>

                    </tr>
                    </thead>
                    <tbody>
                    {filteredOrders.slice(0, 300).map((order) => {
                        const orderNumberWithB = `B${order.order_number}`;
                        const dbMatch = Object.values(dbCollections).flat().find(
                            (entry) => entry.id === orderNumberWithB
                        );

                        // Case-insensitive email match
                        const emailMatch = Object.keys(dbCollections).some(
                            (dbEmail) => dbEmail.toLowerCase() === order.email?.toLowerCase()
                        );

                        // Case-insensitive code match
                        const codeMatch = Object.values(dbCollections)
                            .flat()
                            .some(
                                (entry) =>
                                    entry["Cod Reducere"]?.toLowerCase() ===
                                    order.discount_codes?.[0]?.code?.toLowerCase()
                            );

                        const daysDifference = dbMatch
                            ? calculateDaysDifference(order.created_at)
                            : null;
                        const dbCheck = dbMatch
                            ? dbMatch.status === "in asteptare"
                                ? `${dbMatch.status} - ${daysDifference}d`
                                : dbMatch.status
                            : "/";


                        return (
                            <tr key={order.id}>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                    {new Date(order.created_at).toLocaleDateString()}
                                </td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>B
                                    {order.order_number}
                                </td>
                                <td
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        color: emailMatch ? "black" : "inherit",
                                        fontWeight: emailMatch ? "800" :"inherit"

                                    }}
                                >
                                    {order.email}
                                </td>
                                <td
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        color: codeMatch ? "green" : "inherit",
                                        fontWeight: emailMatch ? "800" :"inherit"
                                    }}
                                >
                                    {order.discount_codes?.[0]?.code || "/"}
                                </td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                    {parseFloat(order.current_total_price || 0).toLocaleString()}
                                </td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                    {dbCheck}
                                </td>

                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                    <span style={{ marginRight: "5px" }}>
                                        {order.financial_status === "paid" ? "💰" : ""}
                                    </span>
                                                                    <span style={{ marginRight: "5px" }}>
                                        {order.fulfillment_status === "fulfilled" ? "🚛" : ""}
                                    </span>
                                                                    <span style={{ marginRight: "5px" }}>
                                        {
                                            // Check if fulfillments exist and if any of them have shipment_status as "delivered"
                                            order.fulfillments?.some(f => f.shipment_status === "delivered") ? "📦" : ""
                                        }
                                    </span>
                                    <span style={{ marginRight: "5px" }}>
                                        {order.refunds?.length > 0 ? "🔄" : ""}
                                    </span>
                                </td>

                            </tr>
                        );
                    })}
                    </tbody>

                </table>
            ) : (
                <p>No orders found.</p>
            )}
        </div>
    );
};

export default OrderTable;
